import React from "react";
import Typography from "@material-ui/core/Typography";
import { Icon } from '@iconify/react';
import { Box, Stack, Button } from "@material-ui/core";
import { useState } from "react";
import { useSelector } from "../../redux/store";

export default function DialPadDtmf() {
const { sendDtmf } = useSelector(state => state.janus);

    return (
        <Stack spacing={1}>
            <Stack direction={"row"} justifyContent={'center'} spacing={1}>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('1')}>1</Button>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('2')}>2</Button>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('3')}>3</Button>
            </Stack>
            <Stack direction={"row"} justifyContent={'center'} spacing={1}>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('4')}>4</Button>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('5')}>5</Button>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('6')}>6</Button>
            </Stack>
            <Stack direction={"row"} justifyContent={'center'} spacing={1}>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('7')}>7</Button>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('8')}>8</Button>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('9')}>9</Button>
            </Stack>
            <Stack direction={"row"} justifyContent={'center'} spacing={1}>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('*')}>*</Button>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('0')}>0</Button>
                <Button variant="outlined" sx={{ color: "white" }} onClick={()=>sendDtmf('#')}>#</Button>
            </Stack>
        </Stack>
    );
}
